export enum OFFSET_PERIOD_TYPE {
  MINUTES = 'Minutes',
  HOURS = 'Hours',
  DAYS = 'Days',
}
export enum OFFSET_OPERATOR {
  PLUS = '+',
  MINUS = '-',
}
